import React, { useState, useEffect } from 'react';

const LoadingScreen = () => {
  const [messageIndex, setMessageIndex] = useState(0);
  
  // These are the trust-building messages for SiftCard
  const messages = [
    "Sift is scanning 100+ Indian credit card reward charts...",
    "Analyzing HDFC & Axis bank devaluation updates (March 2026)...",
    "Calculating your specific milestone benefits...",
    "Optimizing your wallet for maximum cash-back...",
    "Finalizing your personalized reward roadmap..."
  ];

  useEffect(() => {
    // Set up the interval to cycle through messages
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, 2800); 

    // CLEANUP: This stops the timer if the component unmounts
    return () => clearInterval(interval);

    // Dependency array is empty [] to avoid the Linter error 
    // and ensure the timer starts only once.
  }, [messages.length]);

  return (
    <div className="flex flex-col items-center justify-center py-32 animate-in fade-in zoom-in-95 duration-700">
      
      {/* MODERN GLOWING SPINNER */}
      <div className="relative w-24 h-24 mb-10">
        <div className="absolute inset-0 border-4 border-blue-500/10 rounded-full"></div>
        <div className="absolute inset-0 border-4 border-t-emerald-400 border-r-blue-500 rounded-full animate-spin shadow-[0_0_15px_rgba(59,130,246,0.3)]"></div>
        <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
        </div>
      </div>

      {/* DYNAMIC MESSAGE */}
      <div className="h-16 flex items-center justify-center">
        <h2 
          key={messageIndex} 
          className="text-xl md:text-2xl font-semibold text-white text-center animate-in slide-in-from-bottom-2 fade-in duration-500 px-4"
        >
          {messages[messageIndex]}
        </h2>
      </div>

      {/* STATUS INDICATOR */}
      <p className="text-slate-500 text-sm mt-8 font-medium tracking-widest flex items-center gap-2 uppercase">
        <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-ping"></span>
        AI Audit In Progress
      </p>
    </div>
  );
};

export default LoadingScreen;
